import { observer } from 'mobx-react';

import { DealCompare } from '@assets/component/DealCompare/DealCompare';
import { DealDashboard } from '@assets/component/DealDashboard/DealDashboard';
import { DealDetails } from '@assets/component/DealDetails/DealDetails';
import { DealScoreBreakdown } from '@assets/component/DealScoreBreakdown/DealScoreBreakdown';
import { Header } from '@assets/component/Header/Header';
import { Icon } from '@assets/component/Icons/Icons';
import { TaskPage } from '@assets/component/TaskPage/TaskPage';
import { Flex } from '@assets/component/UI/Flex/Flex';
import { useOnPageLoad } from '@assets/hooks/useOnPageLoad';
import {
    UIDealDetailsTabs,
    useClientSettingStore,
    useSetPageTitle,
    useStore,
    useStoreUI
} from '@assets/model/Store';
import { useNavUtils } from '@assets/utils/NavUtils';
import { useEffect, useState } from 'react';
import { Nav, Tab, Tabs } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import DealChat from './DealChat';
import { DealFlowise } from './DealFlowise';
import { DealOutputs } from './DealOutputs';
import * as style from './DealView.module.less';
import { AdminSection } from '@assets/component/AdminSection/AdminSection';
import { WorkStreamPage } from './WorkstreamsPage';
import { DealFlowiseChat } from './DealFlowiseChat/DealFlowiseChat';
import DealViewSidebar from '@assets/component/DealViewSidebar/DealViewSidebar';
import { DealChat_NoChat } from '@assets/component/ChatPage/ChatPage_NoChat';

require('./DealView.css');

const DealView = observer(() => {
    const { id } = useParams();
    const store = useStore();
    const uiStore = useStoreUI();
    const clientStore = useClientSettingStore();
    const navUtils = useNavUtils();
    useEffect(() => {
        if (!store.isLoaded) {
            return;
        }
        if (!store.reportDataDB.hasOwnProperty(id)) {
            navUtils.home();
        }
    }, [store.isLoaded]);

    useOnPageLoad('DEAL_VIEW', () => {
        uiStore.resetDealView();
    });

    useSetPageTitle(store.query?.value('company_name') ?? '');

    useEffect(() => {
        if (id) {
            console.log('Setting report id to', id);
            store.selectedReportId = id;
        }
    }, [id]);

    useEffect(() => {
        if (!uiStore.isKeyTabDown) {
            return;
        }

        const values = Object.values(UIDealDetailsTabs);
        const currentIndex = values.indexOf(uiStore.dealViewTab);
        uiStore.dealViewTab =
            values[
                (currentIndex +
                    (uiStore.isKeyShiftKeyDown ? -1 : 1) +
                    values.length) %
                    values.length
            ];
    }, [uiStore.isKeyTabDown]);

    if (store.query == null) {
        return null;
    }

    const isRagEnabled = clientStore.showRagChat;
    const chatElement = isRagEnabled ? <DealChat /> : <DealChat_NoChat />;
    const returnActivePanel = () => {
        switch (uiStore.dealViewTab) {
            case UIDealDetailsTabs.DASHBOARD:
                return <DealDashboard />;
            case UIDealDetailsTabs.DETAILS:
                return <DealDetails />;
            case UIDealDetailsTabs.COMPARE:
                return <DealCompare />;
            case UIDealDetailsTabs.SCORE_BREAKDOWN:
                return <DealScoreBreakdown />;
            case UIDealDetailsTabs.FLOWISE_CHAT:
                return <DealFlowiseChat />;
            case UIDealDetailsTabs.WORKSTREAMS:
                return <WorkStreamPage />;
            case UIDealDetailsTabs.TASK_VIEW_DEBUG:
                return <TaskPage manualSetTaskId="write_short_story" />;
            case UIDealDetailsTabs.CHAT:
                return chatElement;
            case UIDealDetailsTabs.FLOWISE:
                return <DealFlowise />;
            case UIDealDetailsTabs.OUTPUTS:
                return <DealOutputs />;
            default:
                return <div>Unknown Tab</div>;
        }
    };
    const do_we_have_pdf = store.query.report_has_pdf;

    return (
        <>
            <DealViewSidebar />
            <div
                className={'d-flex justify-content-center'}
                style={{
                    height: '100%',
                    paddingLeft: 'var(--current-sidebar-width)',
                    transition: 'padding-left 0.2s ease',
                    backgroundColor: 'white'
                }}
            >
                <AdminSection />
                <Flex direction="column" className={'h-100 w-100'}>
                    <Header
                        disableTicker={true}
                        showDealDbLink={true}
                        showScore={
                            true &&
                            clientStore.showAggregateScores &&
                            do_we_have_pdf
                        }
                        showShadow={false}
                    />

                    {/* <div className={style.tabsShadow}></div> */}
                    <Flex
                        style={{
                            paddingLeft: 'var(--main-container-side-padding)',
                            paddingRight: 'var(--main-container-side-padding)',
                            position: 'relative',
                            backgroundColor: 'var(--content-background-color)',
                            flex: 1,
                            minHeight: 0,
                            overflow: 'hidden',
                            width: '100%'
                        }}
                    >
                        {returnActivePanel()}
                    </Flex>
                </Flex>
            </div>
        </>
    );
});

export default DealView;
